// Blog post data structure for API-driven content
export interface BlogPost {
  id: string;
  slug: string;
  slugDe?: string;
  titleKey: string;
  excerptKey: string;
  dateKey: string;
  date: string; // ISO format for sorting
  image: string;
  contentKey?: string; // For full blog post content
  author: string;
  tags: string[];
  tagsDe?: string[];
  language: 'de' | 'en' | 'both';
}

// This will be replaced by API/CMS data in the future
export const blogPosts: BlogPost[] = [
  {
    id: '29',
    slug: 'three-secret-gardens-mala-strana-prague',
    slugDe: 'drei-gaerten-kleinseite-prag',
    titleKey: 'blog.post29.title',
    excerptKey: 'blog.post29.excerpt',
    dateKey: 'blog.post29.date',
    date: '2026-04-16',
    image: '/images/blog-gardens.jpg',
    contentKey: 'blog.post29.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Malá Strana gardens Prague', 'Palace Gardens below Prague Castle', 'Vojanovy sady',
      'Wallenstein Garden Prague', 'Prague hidden gardens', 'Prague free gardens',
      'Prague UNESCO gardens', 'Prague Baroque gardens', 'secret gardens Prague', 'Prague Castle gardens',
    ],
    tagsDe: [
      'Kleinseitner Gärten Prag', 'Palastgärten unter der Prager Burg', 'Vojanovy sady',
      'Waldsteingarten Prag', 'Prag versteckte Gärten', 'kostenlose Gärten Prag',
      'Prag UNESCO Gärten', 'Prager Barockgärten', 'geheime Gärten Prag', 'Prager Burg Gärten',
    ],
    language: 'both',
  },
  {
    id: '28',
    slug: 'wallenstein-garden-prague',
    slugDe: 'waldstein-garten-prag',
    titleKey: 'blog.post28.title',
    excerptKey: 'blog.post28.excerpt',
    dateKey: 'blog.post28.date',
    date: '2026-04-16',
    image: '/images/blog-gardens-2.jpg',
    contentKey: 'blog.post28.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Wallenstein Garden Prague', 'Valdštejnská zahrada', 'Prague gardens', 'Malá Strana Prague',
      'Prague hidden gems', 'Baroque garden Prague', 'Prague stalactite wall', 'Adriaen de Vries Prague',
      'Prague Senate garden', 'free things to do Prague',
    ],
    tagsDe: [
      'Waldsteingarten Prag', 'Valdštejnská zahrada', 'Prager Gärten', 'Kleinseite Prag',
      'Prag Geheimtipps', 'Barockgarten Prag', 'Tropfsteinwand Prag', 'Adriaen de Vries Prag',
      'Tschechischer Senat Garten', 'kostenlose Sehenswürdigkeiten Prag',
    ],
    language: 'both',
  },
  {
    id: '27',
    slug: 'prague-public-transport-tickets-apps',
    slugDe: 'oeffentlicher-verkehr-prag-tickets-apps',
    titleKey: 'blog.post27.title',
    excerptKey: 'blog.post27.excerpt',
    dateKey: 'blog.post27.date',
    date: '2026-04-15',
    image: '/images/blog-night-prague-min.jpg',
    contentKey: 'blog.post27.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague public transport', 'Lítačka Prague', 'Prague tram tickets', 'Prague metro',
      'PID Prague', 'DPP Prague', 'Prague travel tips', 'IDOS Prague', 'how to use Prague transport',
      'Prague bank card tram', 'Prague tourist transport',
    ],
    tagsDe: [
      'ÖPNV Prag', 'Lítačka Prag', 'Straßenbahn Tickets Prag', 'Prager Metro',
      'PID Prag', 'DPP Prag', 'Prag Reisetipps', 'IDOS Prag', 'Nahverkehr Prag',
      'Bankkarte Tram Prag', 'Prag Transport Touristen',
    ],
    language: 'both',
  },
  {
    id: '26',
    slug: 'how-to-exchange-money-czech-crowns',
    slugDe: 'geld-wechseln-tschechische-kronen',
    titleKey: 'blog.post26.title',
    excerptKey: 'blog.post26.excerpt',
    dateKey: 'blog.post26.date',
    date: '2026-04-14',
    image: '/images/blog-prague-money.jpg',
    contentKey: 'blog.post26.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Czech koruna', 'money exchange Prague', 'Revolut Prague', 'Czech crowns',
      'ATM Prague', 'Prague travel tips', 'Prague tourist scams',
      'best exchange rate Prague', 'dynamic currency conversion', 'Prague money guide',
    ],
    tagsDe: [
      'Tschechische Krone', 'Geld wechseln Prag', 'Revolut Prag', 'Tschechische Kronen',
      'Geldautomat Prag', 'Prag Reisetipps', 'Prag Touristenfallen',
      'bester Wechselkurs Prag', 'Dynamische Währungsumrechnung', 'Prag Geld Guide',
    ],
    language: 'both',
  },
  {
    id: '25',
    slug: 'all-museums-in-prague-complete-guide',
    slugDe: 'alle-museen-in-prag-kompletter-guide',
    titleKey: 'blog.post25.title',
    excerptKey: 'blog.post25.excerpt',
    dateKey: 'blog.post25.date',
    date: '2026-04-13',
    image: '/images/klementinum-library.jpg',
    contentKey: 'blog.post25.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague museums',
      'museums in Prague',
      'Prague art galleries',
      'National Museum Prague',
      'Jewish Museum Prague',
      'Prague Visitor Pass museums',
      'things to do in Prague',
      'Prague culture',
      'Instagram Prague',
      'Prague exhibitions',
    ],
    tagsDe: [
      'Prag Museen',
      'Museen in Prag',
      'Prager Kunstgalerien',
      'Nationalmuseum Prag',
      'Jüdisches Museum Prag',
      'Prague Visitor Pass Museen',
      'Aktivitäten in Prag',
      'Prager Kultur',
      'Instagram Prag',
      'Prag Ausstellungen',
    ],
    language: 'both',
  },
  {
    id: '24',
    slug: 'how-to-choose-prague-tour-guide',
    slugDe: 'wie-man-den-besten-prag-stadtfuehrer-waehlt',
    titleKey: 'blog.post24.title',
    excerptKey: 'blog.post24.excerpt',
    dateKey: 'blog.post24.date',
    date: '2026-04-13',
    image: '/images/charles-bridge-min.jpg',
    contentKey: 'blog.post24.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague tour guide',
      'how to choose a tour guide',
      'Prague private tour',
      'Prague walking tour',
      'certified tour guide Prague',
      'Prague travel tips',
      'Prague tourist traps',
      'private vs group tour Prague',
    ],
    tagsDe: [
      'Prag Stadtführer',
      'Prag Reiseführer wählen',
      'Prag private Tour',
      'Prag Rundgang',
      'zertifizierter Stadtführer Prag',
      'Prag Reisetipps',
      'Prag Touristenfallen',
      'privat vs Gruppenführung Prag',
    ],
    language: 'both',
  },
  {
    id: '23',
    slug: 'prague-visitor-pass-honest-review',
    slugDe: 'prague-visitor-pass-ehrliche-bewertung',
    titleKey: 'blog.post23.title',
    excerptKey: 'blog.post23.excerpt',
    dateKey: 'blog.post23.date',
    date: '2026-04-13',
    image: '/images/old-town-square.jpg',
    contentKey: 'blog.post23.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague Visitor Pass', 'Prague tourist card', 'Prague money saving', 'Prague public transport',
      'Prague Castle tickets', 'Prague Jewish Quarter', 'Prague Zoo', 'Kutná Hora day trip',
      'Prague travel tips', 'Prague budget guide',
    ],
    tagsDe: [
      'Prague Visitor Pass', 'Prag Touristenkarte', 'Prag Geld sparen', 'Prag öffentliche Verkehrsmittel',
      'Prager Burg Tickets', 'Prager Judenviertel', 'Prager Zoo', 'Kutná Hora Tagesausflug',
      'Prag Reisetipps', 'Prag Budget Ratgeber',
    ],
    language: 'both',
  },
  {
    id: '22',
    slug: 'prague-imax-kafka-grave-vinohrady-guide',
    slugDe: 'prag-imax-kafka-grab-vinohrady-guide',
    titleKey: 'blog.post22.title',
    excerptKey: 'blog.post22.excerpt',
    dateKey: 'blog.post22.date',
    date: '2026-04-13',
    image: '/images/atriumflora-b.jpg',
    contentKey: 'blog.post22.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'IMAX Prague', 'Cinema City Flora', 'Franz Kafka grave', 'Prague Vinohrady',
      'Jiřák farmers market', 'Prague things to do', 'Prague Žižkov', 'New Jewish Cemetery Prague',
      'Christopher Nolan Odyssey', 'Leonardo DiCaprio Prague', 'Prague film locations',
    ],
    tagsDe: [
      'IMAX Prag', 'Cinema City Flora', 'Franz Kafka Grab', 'Prag Vinohrady',
      'Jiřák Bauernmarkt', 'Prag Aktivitäten', 'Prag Žižkov', 'Neuer Jüdischer Friedhof Prag',
      'Christopher Nolan Odyssey', 'Leonardo DiCaprio Prag', 'Prag Drehorte',
    ],
    language: 'both',
  },
  {
    id: '21',
    slug: 'dan-brown-secret-of-secrets-prague',
    slugDe: 'dan-brown-geheimnis-der-geheimnisse-prag',
    titleKey: 'blog.post21.title',
    excerptKey: 'blog.post21.excerpt',
    dateKey: 'blog.post21.date',
    date: '2026-04-13',
    image: '/images/blog-secret-of-secrets-prague.jpg',
    contentKey: 'blog.post21.content',
    author: 'Martin Man',
    tags: [
      'Dan Brown Prague', 'The Secret of Secrets', 'Dan Brown new book', 'Prague mysteries',
      'Prague alchemy', 'Rudolf II Prague', 'Prague coded history', 'Masonic Prague',
      'Prague Kabbalah', 'Prague literary tour', 'Prague hidden history',
    ],
    tagsDe: [
      'Dan Brown Prag', 'Das Geheimnis der Geheimnisse', 'Dan Brown neues Buch', 'Prag Geheimnisse',
      'Prag Alchemie', 'Rudolf II Prag', 'Prager kodierte Geschichte', 'Freimaurei Prag',
      'Prag Kabbala', 'Prager Literatur-Tour', 'Verborgene Geschichte Prags',
    ],
    language: 'both',
  },
  {
    id: '20',
    slug: 'best-day-trips-from-prague',
    slugDe: 'beste-tagesausfluege-von-prag',
    titleKey: 'blog.post20.title',
    excerptKey: 'blog.post20.excerpt',
    dateKey: 'blog.post20.date',
    date: '2026-01-15',
    image: '/images/blog-day-trips.jpg',
    contentKey: 'blog.post20.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Day trips from Prague', 'Kutná Hora', 'Český Krumlov', 'Karlštejn', 'Terezín', 'Karlovy Vary', 'Konopiště', 'Czech castles', 'UNESCO Czech Republic', 'Prague excursions'],
    tagsDe: ['Tagesausflüge von Prag', 'Kutná Hora', 'Český Krumlov', 'Karlštejn', 'Theresienstadt', 'Karlsbad', 'Konopiště', 'Tschechische Schlösser', 'UNESCO Tschechien', 'Prag Ausflüge'],
    language: 'both',
  },
  {
    id: '19',
    slug: 'prague-castle-complete-guide',
    slugDe: 'prager-burg-vollstaendiger-besucher-guide',
    titleKey: 'blog.post19.title',
    excerptKey: 'blog.post19.excerpt',
    dateKey: 'blog.post19.date',
    date: '2026-02-01',
    image: '/images/blog-prague-castle.jpg',
    contentKey: 'blog.post19.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Prague Castle', 'St Vitus Cathedral', 'Golden Lane', 'Old Royal Palace', 'Prague Castle tour', 'Prague Castle tickets', 'Prague Castle opening hours', 'Visit Prague Castle'],
    tagsDe: ['Prager Burg', 'Veitsdom', 'Goldenes Gässchen', 'Alter Königspalast', 'Burgtour Prag', 'Prager Burg Tickets', 'Prager Burg Öffnungszeiten', 'Prager Burg besuchen'],
    language: 'both',
  },
  {
    id: '18',
    slug: 'prague-food-guide',
    slugDe: 'prag-kulinarik-guide',
    titleKey: 'blog.post18.title',
    excerptKey: 'blog.post18.excerpt',
    dateKey: 'blog.post18.date',
    date: '2026-02-15',
    image: '/images/blog-food-prague.jpg',
    contentKey: 'blog.post18.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Prague food', 'Czech cuisine', 'Svíčková', 'Czech beer', 'Where to eat Prague', 'Prague restaurants', 'Prague food guide', 'Czech traditional food', 'Náplavka market'],
    tagsDe: ['Prag Essen', 'Tschechische Küche', 'Svíčková', 'Tschechisches Bier', 'Wo essen Prag', 'Prag Restaurants', 'Prag Kulinarik', 'Tschechische Traditionsküche', 'Náplavka Markt'],
    language: 'both',
  },
  {
    id: '17',
    slug: 'autumn-in-prague',
    slugDe: 'prag-im-herbst',
    titleKey: 'blog.post17.title',
    excerptKey: 'blog.post17.excerpt',
    dateKey: 'blog.post17.date',
    date: '2026-03-01',
    image: '/images/blog-autumn-prague.jpg',
    contentKey: 'blog.post17.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Autumn in Prague', 'Prague in fall', 'Prague October', 'Prague September', 'Signal Festival Prague', 'Prague foliage', 'Wine harvest Prague', 'Things to do Prague autumn'],
    tagsDe: ['Prag im Herbst', 'Prag Herbst', 'Prag Oktober', 'Prag September', 'Signal Festival Prag', 'Herbstlaub Prag', 'Weinlese Prag', 'Was tun Prag Herbst'],
    language: 'both',
  },
  {
    id: '16',
    slug: 'summer-in-prague',
    slugDe: 'prag-im-sommer',
    titleKey: 'blog.post16.title',
    excerptKey: 'blog.post16.excerpt',
    dateKey: 'blog.post16.date',
    date: '2026-03-15',
    image: '/images/blog-summer-prague.jpg',
    contentKey: 'blog.post16.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Summer in Prague', 'Prague in summer', 'Prague June July August', 'Things to do Prague summer', 'Prague outdoor', 'Náplavka Prague', 'Prague beer garden', 'Prague summer events'],
    tagsDe: ['Prag im Sommer', 'Sommer in Prag', 'Prag Juni Juli August', 'Was tun Prag Sommer', 'Prag Outdoor', 'Náplavka Prag', 'Prag Biergarten', 'Prag Sommerevents'],
    language: 'both',
  },
  {
    id: '15',
    slug: 'spring-in-prague',
    slugDe: 'prag-im-fruehling',
    titleKey: 'blog.post15.title',
    excerptKey: 'blog.post15.excerpt',
    dateKey: 'blog.post15.date',
    date: '2026-04-01',
    image: '/images/blog-spring-prague.jpg',
    contentKey: 'blog.post15.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Spring in Prague', 'Prague in spring', 'Prague cherry blossoms', 'Petřín blossoms', 'Easter Prague', 'Prague March April May', 'Prague spring events', 'Prague Spring Festival'],
    tagsDe: ['Prag im Frühling', 'Frühling in Prag', 'Prag Kirschblüten', 'Petřín Blüten', 'Ostern Prag', 'Prag März April Mai', 'Prag Frühlingsevents', 'Prager Frühling Festival'],
    language: 'both',
  },
  {
    id: '14',
    slug: 'top-places-to-visit-in-prague-right-now',
    slugDe: 'top-orte-in-prag-jetzt-besuchen',
    titleKey: 'blog.post14.title',
    excerptKey: 'blog.post14.excerpt',
    dateKey: 'blog.post14.date',
    date: '2025-10-26',
    image: '/images/blog-ots-terasa.png',
    contentKey: 'blog.post14.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Things to do in Prague now',
      'Top places in Prague',
      'Prague rooftops',
      'Nightlife Prague 2025',
      'Craft beer Prague',
      'Rooftop bars Prague',
      'Charles Bridge',
      'Old Town Square',
      'Petřín Gardens',
      'Riegrovy Sady',
      'National Gallery Prague',
      'Museum of Decorative Arts',
      'Parks in Prague',
      'Where to go in Prague',
      'Visit Prague'
    ],
    tagsDe: [
      'Was tun in Prag jetzt',
      'Top Orte in Prag',
      'Prager Rooftops',
      'Nachtleben Prag 2025',
      'Craft Beer Prag',
      'Dachbars Prag',
      'Karlsbrücke',
      'Altstädter Ring',
      'Petřín-Gärten',
      'Riegrovy Sady',
      'Nationalgalerie Prag',
      'Museum für Kunstgewerbe',
      'Parks in Prag',
      'Wohin in Prag',
      'Prag besuchen'
    ],
    language: 'both',
  },
  {
    id: '13',
    slug: 'prettiest-winter-views-in-prague',
    slugDe: 'prag-schoenste-orte-aussichten-im-winter',
    titleKey: 'blog.post13.title',
    excerptKey: 'blog.post13.excerpt',
    dateKey: 'blog.post13.date',
    date: '2025-10-25',
    image: '/images/blog-winter-ots.png',
    contentKey: 'blog.post13.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Winter in Prague',
      'Prettiest views Prague',
      'Old Town Prague',
      'Charles Bridge',
      'Photography spots',
      'Itinerary',
      'Things to do in Prague',
      'Where to go in Prague',
      'Visit Prague in winter'
    ],
    tagsDe: [
      'Prag im Winter',
      'Schönste Aussichtspunkte Prag',
      'Altstadt Prag',
      'Karlsbrücke',
      'Fotospots',
      'Reiseroute',
      'Was tun in Prag',
      'Wohin in Prag',
      'Prag im Winter besuchen'
    ],
    language: 'both',
  },
  {
    id: '1',
    slug: 'best-time-to-visit-prague',
    slugDe: 'beste-reisezeit-prag',
    titleKey: 'blog.post1.title',
    excerptKey: 'blog.post1.excerpt',
    dateKey: 'blog.post1.date',
    date: '2024-01-15',
    image: '/images/blog-best-time-min.jpg',
    contentKey: 'blog.post1.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Travel Tips', 'Seasons', 'Planning'],
    tagsDe: ['Reisetipps', 'Jahreszeiten', 'Planung'],
    language: 'both',
  },
  {
    id: '2',
    slug: 'hidden-gems-of-prague',
    slugDe: 'prag-geheimtipps-versteckte-orte',
    titleKey: 'blog.post2.title',
    excerptKey: 'blog.post2.excerpt',
    dateKey: 'blog.post2.date',
    date: '2024-01-08',
    image: '/images/blog-hidden-gems-min.jpg',
    contentKey: 'blog.post2.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Hidden Gems', 'Local Tips', 'Off the Beaten Path'],
    tagsDe: ['Geheimtipps', 'Lokale Tipps', 'Abseits der Touristenpfade'],
    language: 'both',
  },
  {
    id: '3',
    slug: 'prague-at-night-magical-experience',
    titleKey: 'blog.post3.title',
    excerptKey: 'blog.post3.excerpt',
    dateKey: 'blog.post3.date',
    date: '2024-01-01',
    image: '/images/blog-night-prague-min.jpg',
    contentKey: 'blog.post3.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Night Tours', 'Prague Nightlife', 'Photography'],
    tagsDe: ['Nachtführungen', 'Prager Nachtleben', 'Fotografie'],
    language: 'both',
  },
  {
    id: '4',
    slug: 'jewish-quarter-history-and-heritage',
    titleKey: 'blog.post4.title',
    excerptKey: 'blog.post4.excerpt',
    dateKey: 'blog.post4.date',
    date: '2023-12-20',
    image: '/images/blog-jewish-quarter-min.jpg',
    contentKey: 'blog.post4.content',
    author: 'Ing. Zuzana Manová',
    tags: ['History', 'Jewish Quarter', 'Culture'],
    tagsDe: ['Geschichte', 'Jüdisches Viertel', 'Kultur'],
    language: 'both',
  },
  {
    id: '5',
    slug: 'top-21-instagrammable-places-in-prague',
    titleKey: 'blog.post5.title',
    excerptKey: 'blog.post5.excerpt',
    dateKey: 'blog.post5.date',
    date: '2025-10-12',
    image: '/images/charles-bridge-2-min.jpg',
    contentKey: 'blog.post5.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Photography', 'Instagram', 'Viewpoints', 'Itinerary'],
    tagsDe: ['Fotografie', 'Instagram', 'Aussichtspunkte', 'Reiseroute'],
    language: 'both',
  },
  {
    id: '6',
    slug: 'vaclav-havel-tour-prague',
    titleKey: 'blog.post6.title',
    excerptKey: 'blog.post6.excerpt',
    dateKey: 'blog.post6.date',
    date: '2025-10-18',
    image: '/images/blog-havel.jpg',
    contentKey: 'blog.post6.content',
    author: 'Ing. Zuzana Manová',
    tags: ['History', 'Velvet Revolution', 'Culture', 'Havel'],
    tagsDe: ['Geschichte', 'Samtene Revolution', 'Kultur', 'Havel'],
    language: 'both',
  },
  {
    id: '7',
    slug: 'klementinum-baroque-library-prague',
    titleKey: 'blog.post7.title',
    excerptKey: 'blog.post7.excerpt',
    dateKey: 'blog.post7.date',
    date: '2025-10-18',
    image: '/images/klementinum-library.jpg',
    contentKey: 'blog.post7.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Klementinum', 'Library', 'History', 'Old Town'],
    tagsDe: ['Klementinum', 'Bibliothek', 'Geschichte', 'Altstadt'],
    language: 'both',
  },
  {
    id: '8',
    slug: 'klementinum-astronomical-tower-meridian-room',
    titleKey: 'blog.post8.title',
    excerptKey: 'blog.post8.excerpt',
    dateKey: 'blog.post8.date',
    date: '2025-10-18',
    image: '/images/klementinum-tower.jpg',
    contentKey: 'blog.post8.content',
    author: 'Ing. Zuzana Manová',
    tags: ['Klementinum', 'Astronomy', 'Views', 'Old Town'],
    tagsDe: ['Klementinum', 'Astronomie', 'Aussichten', 'Altstadt'],
    language: 'both',
  },
  {
    id: '9',
    slug: 'what-to-do-in-prague-in-november-2025',
    titleKey: 'blog.post9.title',
    excerptKey: 'blog.post9.excerpt',
    dateKey: 'blog.post9.date',
    date: '2025-10-16',
    image: '/images/old-town-square.jpg',
    contentKey: 'blog.post9.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague in November',
      'Things to do in Prague',
      'Prague events November',
      'Things to do in Prague now',
      'Prague November weather',
      'Prague itinerary',
      'Visit Prague',
      'Prague travel guide'
    ],
    tagsDe: [
      'Prag im November',
      'Was tun in Prag',
      'Prag Events November',
      'Aktivitäten in Prag',
      'Prag November Wetter',
      'Prag Reiseroute',
      'Prag besuchen',
      'Prag Reiseführer'
    ],
    language: 'both',
  },
  {
    id: '10',
    slug: 'top-prague-gardens-to-visit',
    titleKey: 'blog.post10.title',
    excerptKey: 'blog.post10.excerpt',
    dateKey: 'blog.post10.date',
    date: '2025-10-18',
    image: '/images/blog-gardens.jpg',
    contentKey: 'blog.post10.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Prague gardens',
      'Prettiest Prague gardens',
      'Must-visit Prague',
      'Prague Castle viewpoints',
      'Vrtba Garden',
      'Wallenstein Garden',
      'Royal Garden',
      'Palace Gardens below Prague Castle',
      'Hidden gems Prague',
      'Prague photo spots',
      'Visit Prague'
    ],
    tagsDe: [
      'Prager Gärten',
      'Schönste Prager Gärten',
      'Must-See Prag',
      'Burg Aussichtspunkte',
      'Vrtba-Garten',
      'Wallenstein-Garten',
      'Königlicher Garten',
      'Palastgärten unter der Burg',
      'Versteckte Schätze Prag',
      'Prag Fotospots',
      'Prag besuchen'
    ],
    language: 'both',
  },
  {
    id: '11',
    slug: 'strahov-monastery-prague',
    titleKey: 'blog.post11.title',
    excerptKey: 'blog.post11.excerpt',
    dateKey: 'blog.post11.date',
    date: '2025-10-19',
    image: '/images/strahov-monastery.jpg',
    contentKey: 'blog.post11.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Strahov Monastery',
      'Prague viewpoints',
      'Baroque libraries',
      'Petřín',
      'Prague Castle area',
      'Old Town views',
      'Visit Prague',
      'Prague itinerary',
      'Photography'
    ],
    tagsDe: [
      'Strahover Kloster',
      'Prager Aussichtspunkte',
      'Barockbibliotheken',
      'Petřín',
      'Burggebiet',
      'Altstadtblicke',
      'Prag besuchen',
      'Prag Reiseroute',
      'Fotografie'
    ],
    language: 'both',
  },
  {
    id: '12',
    slug: 'franz-kafka-places-in-prague',
    slugDe: 'franz-kafka-orte-in-prag',
    titleKey: 'blog.post12.title',
    excerptKey: 'blog.post12.excerpt',
    dateKey: 'blog.post12.date',
    date: '2025-10-19',
    image: '/images/blog-kafka.jpg',
    contentKey: 'blog.post12.content',
    author: 'Ing. Zuzana Manová',
    tags: [
      'Kafka', 'Franz Kafka', 'Kafka in Prague', 'Kafka itinerary', 'Kafka walking route',
      'Kafka Museum Prague', 'Golden Lane Kafka', 'Old Town Prague', 'Jewish Quarter Prague',
      'Prague literary walk', 'Prague culture', 'Visit Prague'
    ],
    tagsDe: [
      'Kafka', 'Franz Kafka', 'Kafka in Prag', 'Kafka Route', 'Kafka Rundgang',
      'Kafka Museum Prag', 'Goldenes Gässchen Kafka', 'Altstadt Prag', 'Jüdisches Viertel Prag',
      'Literarischer Spaziergang', 'Prager Kultur', 'Prag besuchen'
    ],
    language: 'both',
  },
];

// API endpoint structure (for future implementation)
export const BlogAPI = {
  // GET /api/blog - Get all blog posts
  getAllPosts: async (): Promise<BlogPost[]> => {
    // This will be replaced with actual API call
    return blogPosts;
  },

  // GET /api/blog/:slug - Get single blog post by slug
  getPostBySlug: async (slug: string): Promise<BlogPost | null> => {
    // This will be replaced with actual API call
    const post = blogPosts.find((p) => p.slug === slug);
    return post || null;
  },

  // POST /api/blog - Create new blog post (requires authentication)
  createPost: async (post: Omit<BlogPost, 'id'>): Promise<BlogPost> => {
    // This will be replaced with actual API call
    // For now, this is just a placeholder
    const newPost: BlogPost = {
      ...post,
      id: String(blogPosts.length + 1),
    };
    return newPost;
  },

  // PUT /api/blog/:id - Update blog post (requires authentication)
  updatePost: async (id: string, post: Partial<BlogPost>): Promise<BlogPost | null> => {
    // This will be replaced with actual API call
    return null;
  },

  // DELETE /api/blog/:id - Delete blog post (requires authentication)
  deletePost: async (id: string): Promise<boolean> => {
    // This will be replaced with actual API call
    return false;
  },
};

// Helper function to generate blog post JSON files
export const exportBlogPostToJSON = (post: BlogPost): string => {
  return JSON.stringify(post, null, 2);
};

// Helper function to import blog post from JSON
export const importBlogPostFromJSON = (json: string): BlogPost => {
  return JSON.parse(json) as BlogPost;
};
